import { defaultPageProps, defaultProps } from '../../../app/browser/analyticsDefaultProperties';

const activityLocation = 'SP : Welcome App Download';

export default {
  identify: {},
  page: {
    name: activityLocation,
    properties: defaultPageProps,
  },
  elements: {
    'app-download--link-android': {
      click: {
        name: 'Item Clicked',
        properties: {
          ...defaultProps,
          description: 'Android Pro App',
          activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>',
        },
      },
    },
    'app-download--link-ios': {
      click: {
        name: 'Item Clicked',
        properties: {
          ...defaultProps,
          description: 'iOS Pro App',
          activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>',
        },
      },
    },
    'app-download--escape-link': {
      click: {
        name: 'Item Clicked',
        properties: {
          ...defaultProps,
          description: 'No Thanks',
          activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>',
        },
      },
    },
    'app-download--send-sms-button': {
      click: {
        name: 'Item Clicked',
        properties: {
          ...defaultProps,
          description: 'Welcome Send Link',
          activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/welcomeDownloadAnalytics.js